// extracted by mini-css-extract-plugin
export default {"draggable":"Draggable_draggable__aQU9u","clickable":"Draggable_clickable__Dz9jh"};